import {
  BuyOrderType,
  Expiry,
  SellOrderType,
} from 'global/Securities/types/transaction';
import { Target } from 'typings/api/shareTradeTarget';
import create from 'zustand';

interface State {
  isVisible: boolean;
  selectedUsers: Record<string, Target>;
  sharedUsers: Record<string, Target>;
  orderType?: BuyOrderType | SellOrderType;
  expiry?: Expiry;
  isDayTrade?: boolean;
}

interface Actions {
  setIsVisible(isVisible: boolean): void;
  setSelectedUsers(selectedUsers: Record<string, Target>): void;
  setSharedUsers(selectedUsers: Record<string, Target>): void;
  setOrderType(orderType: BuyOrderType | SellOrderType): void;
  setExpiry(expiry: Expiry): void;
  setIsDayTrade(isDayTrade: boolean): void;
  resetShareTradeModal(): void;
}

const initialState: State = {
  isVisible: false,
  selectedUsers: {},
  sharedUsers: {},
  orderType: undefined,
  expiry: undefined,
  isDayTrade: false,
};

const useShareTradeModal = create<State & Actions>((set) => ({
  ...initialState,
  setIsVisible: (isVisible) => {
    set({ isVisible });
  },
  setSelectedUsers: (selectedUsers) => {
    set({ selectedUsers });
  },
  setSharedUsers: (sharedUsers) => {
    set({ sharedUsers });
  },
  setOrderType: (orderType) => {
    set({ orderType });
  },
  setExpiry: (expiry) => {
    set({ expiry });
  },
  setIsDayTrade: (isDayTrade) => {
    set({ isDayTrade });
  },
  resetShareTradeModal: () => {
    set(initialState);
  },
}));

export default useShareTradeModal;
